export default __webpack_public_path__ + "static/massage_men-1ea1e1bc1fc50d420f56844684687309.jpg";